import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class BudgetKindItemAPI extends DIApi {
  controllerName = 'BudgetKindItems';
  
  /**
  * Chuyển Loại khoản hạch toán
  * @returns
  */
  async transferBudgetKindItem(fromKindItem, toKindItem, hasPeriod, from, to) {
    const apiUrl = this.getAPIUrl();

    const request = {
      url: apiUrl + '/transferBudgetKindItem',
      data: {
        fromKindItem: fromKindItem,
        toKindItem: toKindItem,
        hasPeriod: hasPeriod,
        fromDate: from,
        toDate: to
      },
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu loại theo mã khoản
   * dvhung2 1/6/2023
   */
  getBudgetKindBySubKindCode(budgetSubKindItemCode) {
    const request = {
      url: [this.getAPIUrl(), `DataBudgetKind?budgetSubKindItemCode=${budgetSubKindItemCode}`].join('/'),
    };

    return httpClient.getAsync(request);
  }
  /**
   * Chuyển dữ liệu danh mục loại khoản
   * @author nnninh 02/06/2023
   * @param {*} payload
   * @returns
   */
  async updateBudgetKindItemsData(payload) {
    const request = {
      url: this.getAPIUrl() + '/tranferData',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
}

export default new BudgetKindItemAPI();
